import React, { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
import { ToastContainer } from "react-toastify";
import { getData } from "../../../API";
import { Link } from "react-router-dom";

function UnverifiedDeletedReport() {
  const [deletedData, setDeletedData] = useState([]);
  const gridRef = useRef();

  const fetchDeletedData = async () => {
    try {
      const data = await getData("SurveyDetails/DeletedUnverifiedRecords");
      setDeletedData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching deleted records:", error);
      setDeletedData([]);
    }
  };

  useEffect(() => {
    fetchDeletedData();
  }, []);
  const downloadExcel = () => {
    const tableHeaders = [
      "S.No",
      "Type Of Establishment",
      "Owner Name",
      "Owner Contact No",
      "Surveyor Date",
      "Property House No",
      "Address",
      
    ];

    const tableData = deletedData.map((item, index) => ({
      "S.No": index + 1,
      "Type Of Establishment": item.establishmentType,
      "Owner Name": item.ownerName,
      "Owner Contact No": item.ownerContactNo,
      "Surveyor Date": new Date(item.createdDate).toLocaleDateString(),
      "Property House No": item.houseNo,
      'Address': item.address,
      
    }));

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: "A1" });

    worksheet["!cols"] = Array(tableHeaders.length).fill({ wpx: 120 });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Deleted Records");
    XLSX.writeFile(workbook, "DeletedUnVerifiedRecords.xlsx");
  };

  const columnDefs = [
    {
      headerName: "S.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      headerClass: "grid-header",
      width: 80,
    },
    {
      field: "establishmentType",
      headerName: "Type of Establishment",
      headerClass: "grid-header",
    },
    {
      field: "ownerName",
      headerName: "Owner Name",
      headerClass: "grid-header",
    },
    {
      field: "ownerContactNo",
      headerName: "Owner Contact No",
      headerClass: "grid-header",
    },
    {
      field: "createdDate",
      headerName: "Surveyor Date",
      valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
      headerClass: "grid-header",
    },
    {
      field: "houseNo",
      headerName: "Property House No",
      headerClass: "grid-header",
    },
    { field: "address", headerName: "Address", headerClass: "grid-header" },
  ];

  const defaultColDef = {
    flex: 1,
    resizable: true,
    minWidth: 150,
    sortable: true,
    suppressSizeToFit: true,
  };

  return (
    <div>
      <main className="page-content content">
        <ToastContainer />
        <div className="container-fluid p-0">
          <div className="row align-items-center mb-3">
            <div className="col-md-12">
              <h1 className="title_pages">Deleted UnVerified Records</h1>
            </div>
          </div>
          <div className="row d-flex justify-content-between">
            <div className="col-auto text-start mb-3 mt-3">
              <button
                className="btn"
                onClick={downloadExcel}
                style={{
                  background: "#9CA3AF",
                  color: "white",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                Download Excel <i className="fa-solid fa-download ms-1"></i>
              </button>
            </div>
            <div className="col-auto text-end mb-3 mt-3">
              <Link
                to="/reports"
                className="btn btn-secondary"
                style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
              >
                <i className="fa-solid fa-arrow-left-long me-1"></i> Back
              </Link>
            </div>
          </div>

          <div className="card shadow">
            <div className="card-body">
              <div className="ag-theme-alpine" style={{ width: "100%" }}>
                <AgGridReact
                  ref={gridRef}
                  domLayout="autoHeight"
                  defaultColDef={defaultColDef}
                  rowData={deletedData}
                  columnDefs={columnDefs}
                  pagination={true}
                  paginationPageSize={10}
                  rowHeight={45}
                  paginationPageSizeSelector={[10, 20, 50]}
                  overlayNoRowsTemplate={
                    '<span class="ag-overlay-loading-center">No data available</span>'
                  }
                  onGridReady={(params) => params.api.sizeColumnsToFit()}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default UnverifiedDeletedReport;
